import { Geo, Logger, LoggerTransformer } from "@identity/utils";
import { DataWarehouseService } from "src/services/DataWarehouseService";
import { delay, inject, injectable, injectWithTransform } from "tsyringe";
import { CMPTracker } from "../cmp-tracker";
import { CommunicationService } from "src/services/CommunicationService";

@injectable()
export class KetchTracker extends CMPTracker {
  protected cmpName = "ketch";

  constructor(
    @inject(delay(() => CommunicationService))
    protected readonly communicationService: CommunicationService,
    @inject(Geo) protected geo: Geo,
    @injectWithTransform(Logger, LoggerTransformer, "KetchTracker")
    protected readonly logger: Logger,
    @inject(delay(() => DataWarehouseService))
    protected dataWarehouse: DataWarehouseService,
  ) {
    super(logger, dataWarehouse, geo, communicationService);
  }
}
